import { getSelectedThemeName } from "../themeMeta";

/**
 * Hero overrides for ad-driven landings, keyed by theme then `utm_content`.
 *
 * When a visitor lands with `?utm_content=<slug>`, the homepage hero swaps
 * to the matching `titleLines` / `subhead` so the landing message-matches
 * the ad they clicked. Anything not overridden (e.g. `ctaLabel`,
 * `chevronAriaLabel`) falls through to the theme's default `hero`.
 *
 * Single source of truth for ad copy → hero copy is
 * `backend/internal/ad-copy-drafts.md`. When you change a variant there,
 * update the matching entry here.
 *
 * Unknown / missing slugs return null → no override → default hero renders.
 */
export const HERO_VARIANTS = {
  sanantonio: {
    "aip-sa": {
      titleLines: [
        { text: "How to Be AI-Proof in San Antonio", highlight: "" },
      ],
      subhead: ["Your role might be at risk — but are your skills?"],
    },
    "pyj-sa": {
      titleLines: [{ text: "Protect Your Job From AI", highlight: "" }],
      subhead: ["Your job might be at risk — but is the value you bring?"],
    },
    "pyc-sa": {
      titleLines: [{ text: "Protect Your Career From AI", highlight: "" }],
      subhead: ["Your role might shift. Your value doesn't have to."],
    },
    "m-aip-sa": {
      titleLines: [
        { text: "How San Antonio Marketers Stay AI-Proof", highlight: "" },
      ],
      subhead: ["Waiting it out isn't a plan. Knowing your value is."],
    },
    "aicr-sa": {
      titleLines: [{ text: "Find What AI Can't Replace", highlight: "" }],
      subhead: [
        "AI can copy a lot. Not everything. Find what makes you the exception.",
      ],
    },
  },
};

/**
 * Returns the hero override for the given utm_content under the active theme,
 * or null when nothing matches.
 */
export function getHeroVariant(utmContent, themeName = getSelectedThemeName()) {
  if (!utmContent) return null;
  const themeMap = HERO_VARIANTS[themeName] || {};
  return themeMap[utmContent] || null;
}
